import { createSlice } from "@reduxjs/toolkit";
import { getPrescriptionByAppointment } from "../../reducer/getPrescriptionByAppointment/getPrescriptionByAppointmentReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const getPrescriptionByAppointmentSlice = createSlice({
  name: "getPrescriptionByAppointment",
  initialState,
  reducers: {
    resetPrescriptionByAppointment: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPrescriptionByAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPrescriptionByAppointment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getPrescriptionByAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
      });
  },
});

export const { resetPrescriptionByAppointment } =
  getPrescriptionByAppointmentSlice.actions;

export default getPrescriptionByAppointmentSlice.reducer;
